<template>
<div>
  <v-container>
    <v-row>
      <v-col>
          <Account/>
      </v-col>
    </v-row>
  </v-container>
</div>
</template>

<script>
import Account from '../../components/Admin/Account-data'

export default{
  components:{
    Account
  }
}
</script>


